import React from "react"
import { connect } from "react-redux"
import { goBack, push } from "connected-react-router"
import { Button } from "react-weui"
import { ChevronLeft, Search } from "react-feather"
import { Helmet } from "react-helmet"
import { debounce } from "lodash"
import PropTypes from "prop-types"

import Bar from "./CoolPage.Bar"

import "./CoolPage.less"

/**
 *
 */

class CoolPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: window.innerHeight,
      scrollTop: 0,
    }
    this.debouncedHeight = debounce(() => { this.update() }, 100, { trailing: true })
  }

  update() {
    if (this && this.setState) {
      this.setState({ height: window.innerHeight })
    }
  }

  componentDidMount() {
    // #WARNING this logic was duped in AskRoomNumber.jsx
    window.addEventListener("resize", this.debouncedHeight, false)
    /* I'm afraid to comment this line out.
     * It seems so purposeful, something that someone did, reluctantly, trying to
     * fix an obscure bug, after hours of research and trying alternatives.
     * Or may be Guille is a lazy hack and did this without thinking.
     * We may never know.
     * this.setState({width: document.getElementsByClassName('coolpage')[0].offsetWidth}) */

    /* #HACK update height to avoid nasty bug */
    /* im not even sure this fixes anything */
    setTimeout(this.update, 100)
    setTimeout(this.update, 1000)
    setTimeout(this.update, 5000)
    setTimeout(this.update, 10000)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedHeight, false)
  }

  render() {
    const { props } = this
    const containerProps = (
      props.containerProps
      || {}
    )

    const withFooter = !!(props.footer || props.footerButton)
    return (
      <div
        id={props.id}
        className={`coolpage ${this.props.className}`}
        style={{height: this.state.height}}
        onScroll={e => this.setState({scrollTop: e.target.scrollTop})}
      >
        <Helmet>
          <title>掌上西班牙</title>
          {/* <title>掌上西班牙: {props.title}</title> */}
        </Helmet>

        {
          !props.hideBar && (
            <Bar
              {...props}
              scrollTop={this.state.scrollTop}
              height={this.state.height}
              width={this.state.width}
            />
          )
        }       

        {
          props.subheader && (
            <div className="subheader-wrapper">
              {props.subheader}
            </div>
          )
        }

        <main
          style={{
            marginTop: this.props.fixedBar && !this.props.hideBar ? "56px" : 0,
            ...props.containerStyle,
          }}
          className={withFooter ? "withFooter" : "withoutFooter"}
          {...containerProps}
        >
          { props.children }
          
          {
            /* spacer as the pill-shaped button */
           /* props.footerButton && props.pillButton && (
              <div className="buttonWrapper spacer">
                <Button
                  className={!props.footerDisabled ? "enabled" : "disabled"}
                  disabled={props.footerDisabled}
                >
                  {props.footerLabel}
                </Button>
              </div>
            )*/
          }
        </main>

        { 
          props.footer && (
            <div className="footer-wrapper">
              { props.footer }
            </div>
          )
        }
        { 
          props.footerButton && (
            props.pillButton ? (
              <div className="buttonWrapper">
                <Button
                  className={!props.footerDisabled ? "enabled" : "disabled"}
                  disabled={props.footerDisabled}
                  onClick={() => props.onFooterClick()}
                >
                  {props.footerLabel}
                </Button>
              </div>
            ) : (
              <div className="footer-wrapper default">
                <Button
                  className={!props.footerDisabled ? "enabled" : "disabled"}
                  disabled={props.footerDisabled}
                  onClick={() => props.onFooterClick()}
                >
                  {props.footerLabel}
                </Button>
              </div>
            )
          )
        }
      </div>
    )
  }
}

CoolPage.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,

  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,

  withSearchButton: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf([ "onlyOnBar" ])
  ]),

  gotoSearch: PropTypes.func, // #TODO mandatory if withSearchButton is true
  containerStyle: PropTypes.objectOf(PropTypes.string),
  footerDisabled: PropTypes.bool,
  footerButton: PropTypes.bool,
  pillButton: PropTypes.bool,
  className: PropTypes.string,
  barColor: PropTypes.arrayOf(PropTypes.number),
}

CoolPage.defaultProps = {
  containerStyle: {},
  withSearchButton: false,
  footerDisabled: false,
  footerButton: false,
  pillButton: true,
  className: "",
  barColor: [255, 41, 104],
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  wholeState: state,
  history: state.history,
  routing: state.routing
})

const mapDispatchToProps = dispatch => ({
  goBack: () => dispatch(goBack()),
  push: url => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CoolPage)



// WEBPACK FOOTER //
// ./src/app/catalogo/components/CoolPage.jsx